<template>
  <div class="drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
            <h6 class="text-danger" v-if="non_field_errors">{{ non_field_errors }}</h6>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4>{{stripe_balance && stripe_balance.business_provider ? stripe_balance.business_provider : this.getUser().id_business_provider.name}} Stripe Account</h4>
            <span>Balance: </span> <span>${{stripe_balance ? (stripe_balance.available[0].amount/100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}}</span>
            <br>
            <span>Pending: </span> <span>${{stripe_balance ? (stripe_balance.pending[0].amount/100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}}</span>
            <h6 class="text-danger" v-if="non_field_errors">{{ non_field_errors }}</h6>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">
              Activity Period:
              <select @change="getTransactions()" v-model="selected_week" class="form-control ddown">
                <option v-for="week in weeks" v-bind:value="week.week">
                  {{ week.monday + '-' + week.sunday }}
                </option>
              </select>
              <div>
                Date Payment Processed: {{ weeks[selected_week-1].processed_date }}
                <br>
                Date Payment Received: {{ weeks[selected_week-1].payment_received }}
              </div>

              <div class="col-md-4 col-lg-4 m-0 p-0">
                <div class="m-3">
                  <label class="search-label">Select a Market</label>
                  <select type="text" placeholder="Market" v-model="marketSearch"
                          class="form-control ddown" id="rider-filter" v-on:change="getTransactions()">
                    <option v-for="item in markets">
                      {{item.name}}
                    </option>
                  </select>
                </div>
              </div>

              <div v-if="transactions && transactions.length!=0" class="row" style="margin-top: 2rem;">
                <div class="col-sm-12 col-md-12">
                  <table class="table table-sm table-hover" data-sort-name="Date">
                      <thead>
                        <tr>
                          <th class="result-label text-center" width="10%">
                            <select class="form-control table-select" @change="checkSelection($event)" onfocus="this.selectedIndex = 0">
                              <option selected="selected">
                                Select
                              </option>
                              <option>
                                All
                              </option>
                              <option>
                                None
                              </option>
                            </select>
                          </th>

                          <!-- <th class="text-center result-label" v-for="column in data.resultColumns" v-on:click="sortResults($event)">
                            <div class="row" style="align-items: center; justify-content: center;">
                              {{column}}
                              <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                            </div>
                          </th> -->
                          <th class="result-label" width="30%">
                            Driver
                          </th>
                          <th class="result-label" width="30%">
                            Amount
                          </th>
                          <th class="result-label" width="30%">
                            Market
                          </th>
                          <th class="result-label" width="30%">
                            Status
                          </th>

                        </tr>

                      </thead>
                      <tbody class="col-12">
                        <tr class="ride-item text-xs-center" v-for="tran in transactions" >
                          <!-- Checkbox -->
                          <td class="result-item text-center">
                              <input v-bind:id="tran.id_transaction" v-if="!tran.date_processed && (tran.amount && tran.amount!=0)" type="checkbox" v-bind:value="tran" v-model="checked">
                              <label class="search-label" v-bind:for="tran.id_transaction" style="margin-bottom: 0; top: 0px;"></label>
                          </td>
                          <!-- Name -->
                          <td class="result-item">
                            <span class="name">
                              <!-- <span class="icon icon-user"></span> -->
                              <router-link v-if="tran.to_id_user.id_user" :to="'/driver-dashboard/' + tran.to_id_user.id_user + '/'">
                              {{tran.to_id_user.name_first}} {{tran.to_id_user.name_last}}
                            </router-link>
                            </span>
                          </td>
                          <!-- Amount -->
                          <td class="result-item">
                            <span class="amount pull-right">${{(-tran.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</span>
                          </td>
                          <!-- Market -->
                          <td class="result-item">
                            <span class="amount pull-right">{{tran.to_id_user.id_driver ? tran.to_id_user.id_driver.id_market.code : ''}}</span>
                          </td>
                          <!-- Rider ID -->
                          <td class="result-item">
                            <span class=" icon icon-right-open-big">
                              <font-awesome-icon v-if="tran.date_processed" icon="check" style="color: lawngreen;"/>
                              {{ !tran.date_processed ? 'Unprocessed' : moment(tran.date_processed).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz.guess() + ")" }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div v-if="transactions && transactions.length!=0">
                      <span><button @click="selectAll()">Select All</button></span><span><button @click="unselectAll()">Unselect All</button></span>
                    </div>
                    <div class="list-group list-group-transfers">
                      <div class="list-group-item" v-for="tran in transactions">
                        <span>
                          <input v-bind:id="tran.id_transaction" v-if="!tran.date_processed && (tran.amount && tran.amount!=0)" type="checkbox" v-bind:value="tran" v-model="checked">
                          <label class="search-label" v-bind:for="tran.id_transaction" style="margin-bottom: 0; top: 7px;"></label>
                        </span>
                        <span class="name">
                          <span class="icon icon-user"></span>
                          <router-link v-if="tran.to_id_user.id_user" :to="'/driver-dashboard/' + tran.to_id_user.id_user + '/'">
                          {{tran.to_id_user.name_first}} {{tran.to_id_user.name_last}}
                        </router-link>
                        </span>
                        <span class="amount pull-right">${{(-tran.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</span>
                        <span class="badge icon icon-right-open-big">
                          <font-awesome-icon v-if="tran.date_processed" icon="check" style="color: lawngreen;"/>
                          {{tran.date_processed | moment("MMMM Do, YYYY \\at h:mm a")}}
                        </span>
                      </div>
                    </div> -->
                    <span v-if="transactions && transactions.length!=0">Transfer total: ${{(-total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</span>
                    <br>
                    <span v-if="excluded!=0">Total excluded: ${{(-excluded).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</span>
                </div>
              </div>

              <div v-if="transactions && transactions.length!=0 && checked && checked.length!=0" class="row" style="margin-top: 2rem;">
                <div class="col-xs-12 col-sm-offset-4 col-sm-4">
                  <div class="form-group">
                    <button @click="processTransfers()" class="btn btn-info waves-effect waves-light m-t-10">Process Transfers</button>
                  </div>
                </div>
              </div>

              <div v-if="!transactions || transactions.length==0">
                <span>No data available</span>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Driver Payments',
    },
    name: 'DriverRevenue',
    data () {
      return {
        title: 'Driver Payments',
        isLoading: false,
        loadings: [],
        errors: null,
        non_field_errors: null,
        weeks: null,
        selected_week: 1,
        transactions: null,
        stripe_balance: null,
        checked: [],
        all_valid_transactions: [],
        markets: [],
        marketSearch: '',
        stripeName: '',
      }
    },
    computed: {
      total: function () {
        let res = 0
        for (let index in this.checked) {
          res += this.checked[index].amount
        }
        return res
      },
      excluded: function () {
        let res = 0
        for (let index in this.all_valid_transactions) {
          if (!this.checked || this.checked.length==0 || this.checked.indexOf(this.all_valid_transactions[index]) == -1) {
            res += this.all_valid_transactions[index].amount
          }
        }
        return res
      }
    },
    components: {
      Loading
    },
    methods: {
      showLoading() {
        this.isLoading = true
        this.loadings.push(1)
      },
      hideLoading() {
        if (this.loadings.length > 0) {
          this.loadings.pop()
        }
        if (this.loadings.length == 0) {
          this.isLoading = false
        }
      },
      processTransfers: function () {
        if (-this.total > this.stripe_balance.available[0].amount/100) {
          this.showToastError('Insufficient balance. Please add funds to your Stripe account.')
          return
        } else {
        }

        if(!confirm("Please confirm processing the payments for these drivers")) {
          return
        }

        this.showLoading()
        this.$http
          .post(process.env.API_BASE_URL_CS + 'transactions/', {
            transactions: this.checked
          })
          .then(response => {
            this.getStripeBalance()
            this.getTransactions()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.hideLoading()
          })
      },
      selectAll() {
        this.checked = this.all_valid_transactions
      },
      unselectAll() {
        this.checked = []
      },
      getWeeks: function () {
        // this.showLoading()
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/weeks/?start=1')
          .then(response => {
            this.weeks = response.data
            this.selected_week = this.weeks[0].week
            for (let index in this.weeks) {
              this.weeks[index].monday = this.moment(this.weeks[index].monday).tz('Europe/Lisbon').format("MM/DD/YYYY")
              this.weeks[index].sunday = this.moment(this.weeks[index].sunday).tz('Europe/Lisbon').format("MM/DD/YYYY")
              this.weeks[index].processed_date = this.moment(this.weeks[index].processed_date).tz('Europe/Lisbon').format("MM/DD/YYYY")
              this.weeks[index].payment_received = this.moment(this.weeks[index].payment_received).tz('Europe/Lisbon').format("MM/DD/YYYY")
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
          })
          .finally(() => {
            // this.hideLoading()
          })
      },
      getTransactions: function () {
        this.showLoading()
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/?type=driver_revenue&page_size=999&week=' + this.selected_week + '&market=' + this.marketSearch)
          .then(response => {
            this.transactions = response.data.results
            this.all_valid_transactions = []
            this.checked = []
            for (let index in this.transactions) {
              if (!this.transactions[index].date_processed && this.transactions[index].amount && this.transactions[index].amount!=0) {
                this.all_valid_transactions.push(this.transactions[index])
                this.checked.push(this.transactions[index])
              }
            }
            this.getStripeBalance()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errors = error.response
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.hideLoading()
          })
      },
      getMarkets: function () {
        // this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            this.markets = response.data
            this.marketSearch = this.markets[this.markets.length-1].name
            this.getTransactions()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            // this.isLoading = false
          })
      },
      getStripeBalance: function () {
        // this.showLoading()
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/stripe-balance/' + (this.marketSearch.length > 0 ? '?market=' + this.marketSearch : ''))
          .then(response => {
            this.stripe_balance = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
          })
          .finally(() => {
            // this.hideLoading()
          })
      },
      reset: function () {
        this.errors = null
        this.non_field_errors = null
        this.id_ride = null
      },
      checkSelection: function(event) {
        // this.data.isCheckAll =  ? false : true
        if (event.srcElement.selectedIndex == 1) {
          this.selectAll()
        }
        if (event.srcElement.selectedIndex == 2) {
          this.unselectAll()
        }
      },

    },
    mounted () {
      this.getWeeks()
      this.getStripeBalance()
      this.getMarkets()
    },
    created () {
      // document.title = "Wingz Support | Driver Payments";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    /*position: fixed;*/
    /*bottom: 60px;*/
    /*right: 50%;*/
    margin-top: 20px;
  }
  select.form-control {
    width: initial;
  }
  .table td, .table th {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/DriverPayments.vue